import * as React from 'react';
import classNames from 'classnames';

import { ITableStore } from '../Table';
import { calculateMapping } from '../Table/utils';
import Icon, { IconsAvailable } from '../Icon';

export interface ITableHeadProps {
    /** className to append */
    className?: string;
    /**
     * Internal tableStore data, applied automatically by parent.
     * @ignore
     */
    tableStore?: ITableStore;
}

/**
 * Use this within Table component to render a table header row. Children should be TableHeadCell components.
 */
export default class TableHead extends React.Component<ITableHeadProps, {}> {
    static displayName: string = 'TableHead';

    public render () {
        if (!this.props.tableStore) {
            return null;
        }
        const { tableWidth, headersMapping, headers } = this.props.tableStore;
        const mapper = ((header, index) => {
            return header.props.hidden ? null : <th key={index} className={header.props.className}>{header}</th>;
        });
        let headings;
        if (tableWidth === 0) {
            // not initialized
            headings = headers.map(mapper);
        } else {
            const { visible } = calculateMapping(headersMapping, tableWidth);
            headings = visible.map((item) => {
                if (item.header.props.hidden && !this.props.children) {
                    return null;
                }
                const mappedChildren = React.Children.toArray(this.props.children);
                const realChild = mappedChildren[item.index];

                if (React.isValidElement(realChild)) {
                    return (
                        <th key={item.index} className={classNames(realChild.props.className, {
                            sortable: realChild.props.sortable,
                        })}>
                            {realChild.props.sortable ? (
                                <div className="table-head-sortable" onClick={(e) => {
                                    e.preventDefault();
                                    if (realChild.props.onSort) {
                                        realChild.props.onSort(item);
                                    }
                                }}>
                                    <Icon width={8} height={12} kind={realChild.props.sorted ? ({ asc: 'sortable-asc', desc: 'sortable-desc' })[realChild.props.sorted] as IconsAvailable : 'sortable'}/>
                                    <div>{realChild}</div>
                                </div>
                            ) : (
                                realChild
                            )}
                        </th>
                    );
                } else {
                    return realChild;
                }
            });
        }

        return (
            <thead>
                <tr className={classNames('table-head-default', this.props.className)}>
                    {headings}
                </tr>
            </thead>
        );
    }
}
